import { ConfirmModal } from '@app/components'
import { Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { type FC } from 'react'

import { Modal, type ModalProps } from './Modal'

export interface UnsavedChangesModalProps extends ModalProps {
  isChanged?: boolean
}

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({
  isChanged,
  isLoading,
  children,
  onClose,
  ...props
}) => {
  const [isConfirming, confirmModalHandler] = useDisclosure(false)

  return (
    <>
      <Modal
        isLoading={isLoading}
        onClose={() => {
          if (isChanged || isLoading) {
            confirmModalHandler.open()
          } else {
            onClose()
          }
        }}
        {...props}
      >
        {children}
      </Modal>
      <ConfirmModal
        cancelLabel='Oops, Nevermind'
        closeOnConfirm
        confirmLabel="Yes, I'm Sure"
        opened={isConfirming}
        onClose={confirmModalHandler.close}
        onConfirm={onClose}
        title='Unsaved Changes'
        zIndex={201}
      >
        <Text size='sm'>You have unsaved changes, are you sure you want to cancel?</Text>
      </ConfirmModal>
    </>
  )
}
